import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const departmentURL = `api/v1/departments-app/departments`;

//obtaining the paginated data
export const getDepartment = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${departmentURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllDepartment = () => axiosInstance.get(`${departmentURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDepartment = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${departmentURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getDepartmentById = (id) => axiosInstance.get(`${departmentURL}/retrieve/${id}`);

//creating function
export const createDepartment = (body) => axiosInstance.post(`${departmentURL}/create`, body);
//updating function
export const updateDepartment = (id, body) => axiosInstance.patch(`${departmentURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${departmentURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDepartmentName = (e, cancelToken) =>
  axiosInstance.get(`${departmentURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
